<template>
  <div class="w-full flex flex-col items-start mb-16">
    <h3 class="mb-4 font-medium">{{ userInfo.fieldName }}</h3>
    <div
      class="field field-auto w-full flex items-center justify-between rounded bg-zt-dark-200 border-zt-dark-300 pr relative p-4"
    >
      <div v-if="isLoading" class="image-icon">
        <vue-element-loading
          active
          spinner="spinner"
          duration="1.5"
          color="#4f4f4f"
          size="25"
        />
      </div>
      <div v-else class="image-icon">
        <div
          v-if="image"
          class="w-full h-full bg-zt-white relative overflow"
        >
          <img :src="image" alt="" class="absolute -left-1/2 -top-1/2"/>
        </div>
        <div v-if="!image" class="relative">
          <svg width="80" height="60" viewBox="0 0 160 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_19_1128)">
              <path d="M160 18.3337V101.666C160 111.801 151.801 120 141.666 120H18.3337C16.6663 120 15.0671 119.8
                13.5999 119.333C5.73364 117.267 0 110.133 0 101.666V18.3337C0 8.19946 8.19946 0 18.3337
                0H141.666C151.801 0 160 8.19946 160 18.3337Z" fill="#ECEFF1"/>
              <path d="M46.6663 33.3337C46.6663 40.697 40.697 46.6663 33.3337 46.6663C25.9692 46.6663 20 40.697 20
                33.3337C20 25.9692 25.9692 20 33.3337 20C40.697 20 46.6663 25.9692 46.6663 33.3337Z" fill="#CCCCCC" />
              <path d="M160 86.2671V101.666C160 111.801 151.801 120 141.666 120H18.3337C16.6663 120 15.0671 119.8
                13.5999 119.333L95.0671 37.8662C99.5996 33.3337 107.067 33.3337 111.6 37.8662L160 86.2671Z" fill="#969696" />
              <path d="M113.733 120H18.3337C16.6663 120 15.0671 119.8 13.5999 119.333C5.73364 117.267 0 110.133 0
                101.666V99.5996L38.3997 61.2C42.9333 56.6663 50.4004 56.6663 54.9329 61.2L113.733 120Z" fill="#BDBDBD" />
            </g>
            <defs>
              <clipPath id="clip0_19_1128">
                <rect width="160" height="120" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <zt-button
        icon="box-arrow-down"
        class="flex items-center"
        :disabled="!image"
        @click="downloadImage"
        data-vs-button="download-picture"
      >
        <span>
          {{ $t("message.selfService.taskManager.field.download") }}
        </span>
      </zt-button>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import Employee from '@/apiClient/Employee'
export default {
  name: 'UserPhotoValue',
  components: { VueElementLoading },
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      image: '',
      imageType: '',
      isLoading: false,
      file: ''
    }
  },
  async mounted() {
    if (this.userInfo.value) {
      await this.getUserPhoto(this.userInfo.userId)
    }
  },
  methods: {
    async downloadImage() {
      const blob = new Blob([this.file], { type: this.imageType })
      const imageURL = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = imageURL
      link.download = this.userInfo.userId + '.' + this.imageType.split('/').pop()
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async getUserPhoto(userId) {
      this.image = ''
      this.isLoading = true
      const employeeApi = new Employee()
      try {
        const { headers, data: file } = await employeeApi.getUserPerceptionAvatar(userId, true)
        if (file) {
          this.file = file
          this.imageType = headers['content-type']
          const blob = new Blob([this.file], { type: this.imageType })
          const reader = new FileReader()
          reader.onloadend = () => {
            this.image = reader.result
            this.isLoading = false
          }
          reader.readAsDataURL(blob)
        }
      } catch (e) {
        this.image = ''
        this.isLoading = false
      }
    },
  }
}
</script>

<style scoped lang="scss">
.image-icon {
  width: 80px;
  height: 60px;
  border-radius: 10px;
  overflow: hidden;
}
.field {
  height: 50px;
  border: 1px solid #969696!important;
  .fake-label {
    top: -10px;
    font-size: 0.85rem;
    padding: 1px 5px 0;
  }
  .caret-icon {
    top: 18px;
    right: 15px;
  }
}
.field-auto {
  height: auto!important;
}
.primary-200 {
  color: #4F41A3!important;
  border-color: #4F41A3!important;
}
</style>